(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilublu-app-footer"]) return;
  try {
    
if(!customElements.get('ilublu-app-nudge'))customElements.define('ilublu-app-nudge',class extends HTMLElement{
  connectedCallback(){
    this.abort=new AbortController();const signal=this.abort.signal;
    const ua=navigator.userAgent;
    const platform=/android/i.test(ua)?'android':/iphone|ipod/i.test(ua)?'ios':null;
    if(!platform||navigator.standalone||matchMedia('(display-mode: standalone)').matches)return;
    try{if(sessionStorage.getItem('ilublu-app-dismissed')==='1')return;}catch{}
    const destination=document.querySelector('[data-app-store="'+platform+'"]');
    if(!destination)return;
    this.querySelector('[data-nudge-link]').href=destination.href;
    this.closed=false;this.ready=false;
    this.sync=()=>{
      const film=document.querySelector('ilublu-film,.ilu-hatch,.ilu-workshop');
      const allScenes=[...document.querySelectorAll('ilublu-film,.ilu-hatch,.ilu-workshop')];
      const pastFilm=!film||allScenes.every(scene=>scene.getBoundingClientRect().bottom<100);
      const appPanel=document.querySelector('.ilu-apps');
      const appRect=appPanel?.getBoundingClientRect();
      const panelVisible=appRect&&appRect.top<innerHeight&&appRect.bottom>0;
      const busy=document.activeElement?.matches('input,textarea,select')||document.querySelector('dialog[open],details[open],cart-drawer.active');
      this.hidden=!this.ready||this.closed||!matchMedia('(max-width:749px)').matches||scrollY<innerHeight||!pastFilm||panelVisible||Boolean(busy);
    };
    this.querySelector('button').addEventListener('click',()=>{this.closed=true;this.hidden=true;try{sessionStorage.setItem('ilublu-app-dismissed','1');}catch{}},{signal});
    ['scroll','resize','focusin','focusout','click'].forEach(type=>addEventListener(type,this.sync,{passive:true,signal}));
    this.timer=setTimeout(()=>{if(!signal.aborted){this.ready=true;this.sync();this.observer=new MutationObserver(this.sync);this.observer.observe(document.body,{subtree:true,attributes:true,attributeFilter:['open','class']});}},12000);
  }
  disconnectedCallback(){this.abort?.abort();clearTimeout(this.timer);this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilublu-film"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ilublu-film'))customElements.define('ilublu-film',class extends HTMLElement{
  connectedCallback(){
    if(this.controller)return;
    this.controller=new AbortController();const signal=this.controller.signal;
    this.video=this.querySelector('video');this.chapters=[...this.querySelectorAll('[data-chapter]')];
    this.playButton=this.querySelector('.ilu-film__play');this.progress=0;this.target=0;this.raf=0;this.chapterIndex=-1;
    this.measureCopy=()=>{
      const active=this.chapters.find(chapter=>!chapter.hidden);
      if(!active)return;
      const bottom=active.getBoundingClientRect().bottom-this.querySelector('.ilu-film__stage').getBoundingClientRect().top+20;
      this.style.setProperty('--film-copy-bottom',Math.ceil(bottom)+'px');
    };
    this.measureCopy();
    if(typeof ResizeObserver!=='undefined'){this.copyObserver=new ResizeObserver(this.measureCopy);this.chapters.forEach(chapter=>this.copyObserver.observe(chapter));}
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');
    if(!this.video||this.motion.matches||navigator.connection?.saveData)return;
    const mobile=matchMedia('(max-width:749px)').matches;
    const source=(mobile&&this.video.dataset.mobile)||this.video.dataset.desktop||this.video.dataset.fallback;
    if(!source)return;
    fetch(source,{signal}).then(response=>{if(!response.ok)throw Error('Video unavailable');return response.blob();}).then(blob=>{if(signal.aborted)return;this.objectURL=URL.createObjectURL(blob);this.video.src=this.objectURL;this.video.preload='auto';this.video.load();}).catch(()=>{if(signal.aborted)return;this.video.src=source;this.video.preload='auto';this.video.load();});
    const unlock=()=>{if(this.motion.matches)return;this.video.muted=true;const playback=this.video.play();if(playback)playback.then(()=>{this.video.pause();this.playButton.hidden=true;this.update();}).catch(()=>{this.playButton.hidden=false;});};
    this.playButton.addEventListener('click',unlock,{signal});
    this.video.addEventListener('loadeddata',()=>{
      this.classList.add('is-ready');
      const top=parseFloat(getComputedStyle(this).getPropertyValue('--ilu-header'))||76;
      // Do not insert a long scroll section after someone has already skipped it.
      if(!this.motion.matches&&this.getBoundingClientRect().top>=top-8)this.classList.add('is-enhanced');
      this.update();if(this.classList.contains('is-enhanced'))unlock();
    },{signal});
    this.video.addEventListener('error',()=>{this.classList.remove('is-enhanced','is-ready');this.chapterIndex=-1;this.chapters.forEach((c,i)=>{c.hidden=i!==0;});this.measureCopy();},{signal});
    this.video.addEventListener('seeked',()=>{if(!this.raf)this.raf=requestAnimationFrame(()=>this.draw());},{signal});
    this.update=()=>{
      if(!this.classList.contains('is-enhanced'))return;
      const top=parseFloat(getComputedStyle(this).getPropertyValue('--ilu-header'))||76;
      const rect=this.getBoundingClientRect();this.target=Math.max(0,Math.min(1,(top-rect.top)/(this.offsetHeight-this.querySelector('.ilu-film__stage').offsetHeight)));
      if(!this.raf)this.raf=requestAnimationFrame(()=>this.draw());
    };
    addEventListener('scroll',this.update,{passive:true,signal});addEventListener('resize',this.update,{passive:true,signal});
    this.motion.addEventListener('change',()=>{this.video.pause();this.chapterIndex=-1;this.classList.toggle('is-enhanced',!this.motion.matches&&this.classList.contains('is-ready'));if(this.motion.matches){this.chapters.forEach((c,i)=>{c.hidden=i!==0;});this.video.currentTime=0;this.measureCopy();}else this.update();},{signal});
  }
  draw(){
    this.raf=0;if(this.motion.matches||!this.classList.contains('is-enhanced')||!Number.isFinite(this.video.duration))return;
    this.progress+=(this.target-this.progress)*.22;if(Math.abs(this.target-this.progress)<.0008)this.progress=this.target;
    const index=this.progress<.23?0:this.progress<.52?1:this.progress<.79?2:3;
    if(this.chapterIndex!==index){this.chapters.forEach((c,i)=>{c.hidden=i!==index;});this.chapterIndex=index;this.measureCopy();}
    this.style.setProperty('--film-progress',this.progress);
    const time=this.progress*Math.max(0,this.video.duration-.04);
    if(!this.video.seeking&&Math.abs(this.video.currentTime-time)>.018)this.video.currentTime=time;
    if(Math.abs(this.target-this.progress)>.0008)this.raf=requestAnimationFrame(()=>this.draw());
  }
  disconnectedCallback(){this.controller?.abort();this.copyObserver?.disconnect();cancelAnimationFrame(this.raf);this.video?.pause();if(this.objectURL)URL.revokeObjectURL(this.objectURL);this.controller=null;}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilublu-hatch"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ilu-hatch')){
customElements.define('ilu-hatch',class extends HTMLElement{
connectedCallback(){
this.motion=window.matchMedia('(prefers-reduced-motion: reduce)');
this.tick=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.paint()})};
this.change=()=>{this.classList.toggle('is-ready',!this.motion.matches);this.tick()};
this.motion.addEventListener('change',this.change);
window.addEventListener('scroll',this.tick,{passive:true});window.addEventListener('resize',this.tick,{passive:true});
this.change();
}
paint(){
if(this.motion.matches)return;
const clamp=n=>Math.max(0,Math.min(1,n));
const top=this.getBoundingClientRect().top;
const header=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ilu-header'))||88;
const distance=this.offsetHeight-(window.innerHeight-header);
const p=clamp((header-top)/Math.max(1,distance));
const open=clamp((p-.15)/.55),ease=open*open*(3-2*open);
this.style.setProperty('--egg-opacity',1-clamp(open*3));
this.style.setProperty('--shell-opacity',1-clamp((open-.2)/.35));
this.style.setProperty('--shell-y',(-ease*150)+'px');this.style.setProperty('--shell-x',(ease*45)+'px');this.style.setProperty('--shell-angle',(ease*24+Math.sin(p*45)*(1-open)*1.3)+'deg');
this.style.setProperty('--hello-opacity',clamp((p-.43)/.25));this.style.setProperty('--hello-y',((1-ease)*15)+'px');
this.style.setProperty('--hatch-progress',p);
}
disconnectedCallback(){window.removeEventListener('scroll',this.tick);window.removeEventListener('resize',this.tick);this.motion.removeEventListener('change',this.change);cancelAnimationFrame(this.frame)}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ilublu-workshop"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('ilu-workshop')){
customElements.define('ilu-workshop',class extends HTMLElement{
connectedCallback(){
this.motion=matchMedia('(prefers-reduced-motion: reduce)');
this.tick=()=>{if(this.frame)return;this.frame=requestAnimationFrame(()=>{this.frame=0;this.paint()})};
this.change=()=>{this.classList.toggle('is-ready',!this.motion.matches);this.tick()};
this.motion.addEventListener('change',this.change);addEventListener('scroll',this.tick,{passive:true});addEventListener('resize',this.tick,{passive:true});this.change();
}
paint(){if(this.motion.matches)return;const clamp=x=>Math.max(0,Math.min(1,x));const header=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--ilu-header'))||88;const p=clamp((header-this.getBoundingClientRect().top)/Math.max(1,this.offsetHeight-innerHeight+header));const t=clamp((p-.25)/.45);const smooth=t*t*(3-2*t);this.style.setProperty('--macro-mask',100*(1-smooth)+'%');this.style.setProperty('--camera-scale',1+p*.075);this.style.setProperty('--macro-scale',1+(1-p)*.025);this.style.setProperty('--workshop-progress',p);this.style.setProperty('--step-color',p>.45?'#0878d1':'#143746')}
disconnectedCallback(){removeEventListener('scroll',this.tick);removeEventListener('resize',this.tick);this.motion.removeEventListener('change',this.change);cancelAnimationFrame(this.frame)}
});
}

  } catch(e) { console.error(e); }
})();
})();
